<!--




@Author Chris
@Author Erik
-->

<template lang="html">
  <div class="pageProfile">

    <md-app class="viewport">
      <md-app-toolbar class="md-primary navbar" md-elevation="0">
        <navbar/>
      </md-app-toolbar>

      <md-app-content class="allProfile">

        <div v-if="loaded">
          <coverProfile class="coverProfile"/>

          <div>
            <infoProfile class="infoProfile"/>
            <chapter-list class="cardChapters"/>
          </div>
        </div>
        <div v-else class="centerPage">
          <loader size="l"/>
        </div>
      </md-app-content>

    </md-app>

  </div>
</template>

<script>
import LogRocket from "logrocket";
import navbar from '../toolbar/navbar.vue';
import coverProfile from "../drawer/coverProfile";
import infoProfile from "../drawer/infoProfile";
import chapterList from "../content/chapterList";
import loader from "@/components/shared/loader";
import call from "@/api/calls";

const log = (error, method, data) => {
  LogRocket.captureException(error, {
    extra: {
      method,
      data
    }
  });
}

export default {
  name: 'profile',
  components: {
    navbar,
    coverProfile,
    infoProfile,
    chapterList,
    loader
  },
  data() {
    return {
      loaded: false
    }
  },
  watch: {
    '$route.params.id'() {
      this.loaded = false;
      this.fetchData(this.$route.params.id);
    }
  },
  created() {
    this.fetchData(this.$route.params.id);
  },
  beforeRouteUpdate(to, from, next) {
    // get new user data and send it to params
    this.fetchData(to.params.id)
    .then(() => next());
  },
  methods: {
    fetchData(profileId) {
      return call.profile.get(profileId)
      .then(profile => {
        if(profile != null) {
          this.$route.params.user = profile;
          this.loaded = true;
        }
        else {
          throw "notFound";
        }
      })
      .catch(err => {
        if (err == "notFound")
          this.$router.push({ name: "notFound" });
        else
          log(err, "beforeRouteEnter()", null);
      })
    }
  },
  metaInfo() {
    let user = this.$route.params.user || {};
    return {
      title: user.fullName || "Perfil",
      meta: [
        {name: "robots", content: "index"},
        {name: "keywords", content: "perfil, pessoa"},
        {name: "description", content: user.description || "Perfil da rede social Chapstory."},
        {rel: "canonical", href: `https://www.chapstory.com/p/${this.$route.params.id}`}
      ]
    }
  }
};
</script>

<style scoped>
h3{
margin-top: 5px;
}

.viewport {
  height: 100vh;
  width: 100vw;
  overflow-y: auto;
}

.md-content{
  background-color: #e4f9f54a;
}

.allProfile {
  margin: auto;
  padding: 0;
  /* overflow-y: auto;
  overflow-x: hidden;
  height: calc(100vh - 50px); */
}

.md-toolbar,
.md-toolbar-row,
.md-app-toolbar,
.md-app-toolbar-row {
  width: 100%;
  min-height: 50px !important;
  display: flex;
  align-items: center;
  align-content: center;
  transition: 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  transition-property: opacity, background-color, box-shadow, transform, color,
    min-height;
  will-change: opacity, background-color, box-shadow, transform, color,
    min-height;
  position: sticky;
}

.navbar {
  max-height: 50px;
}

/* .coverProfile{
  height: calc(30vh - 90px);
} */

.infoProfile{
  position: relative;
  float: left;
  min-width: 40%;
  max-width: 40%;
  padding: 16px;
}

.cardChapters{
  position: relative;
  float: right;
  top: 0;
  width: 60%;
}

.centerPage {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

@media (max-width: 631px) {

.allProfile {
  height: 100%;
  overflow-y: auto;
  flex: 1;
  -webkit-box-flex: 1;
}

  .infoProfile{
    min-width: 100%;
  }

  .cardChapters{
    width: 100%;
  }

}
</style>
